export function initAccordion() {

    const $titles = $(".accordion strong");
    const $items = $(".accordion li");

    initAccordion();

    $titles.on("click", function () {
        const $this = $(this);
        if ($this.parent().hasClass("active")) {
            closeAll();
        } else {
            closeAll();
            $this.parent()
                .addClass("active")
                .find(".description").stop().slideDown();
        }
    });

    function initAccordion() {
        $items.each((i, it) => {
            if ($(it).hasClass("active")) {
                $(it).find(".description").slideDown();
            }
        });
    }

    function closeAll() {
        $items.each((i, it) => {
            $(it)
                .removeClass("active")
                .find(".description").stop().slideUp();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js